import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class SpecialOffers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            OFFERS: [],
            CUSTOMER_DET: ''
        };
    }

    fetchSpecialOffersPage(mode,vendor,page) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/specialoffers_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var OFFERS = result.OFFERS;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            that.setState({ LOADING:false, OFFERS:OFFERS, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentDidMount() {
        this.fetchSpecialOffersPage('OFFERS');
    }

    render() { 

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Special Offers';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />
                <div id="appCapsule">
                    <div className="delivery-location cart-item-review">
                        <div className="section mt-2">
                        {this.state.OFFERS.length>0 && this.state.OFFERS.map(offer=>{

                                let OFFER = 0;
                                if(offer.VALUE!=0)
                                {
                                    if(offer.TYPE=='PER')
                                        OFFER = `${offer.VALUE}% Off`;
                                    else if(offer.TYPE='DIS')
                                        OFFER = `&#8377; ${offer.VALUE} Off`;
                                }
                                else
                                    OFFER = 'Free '+offer.TEXT;

                                if(OFFER==0 || OFFER=='null')
                                    OFFER = '';
                                else
                                {
                                    if(offer.CODE!='')
                                        OFFER += ' | ';
                                }

                                return (
                                    <div className="card mb-2" key={offer.ID}>
                                        <div className="card-body pt-2 pb-2">
                                            <h6 className="font-size-12 font-weg-600 mb-05 text-danger"><span dangerouslySetInnerHTML={{ __html: OFFER }} />{offer.CODE}</h6>
                                            {/*<h5 className="font-size-14 font-weg-500 mb-05 mr-1">Product Name</h5>*/}
                                            <p className="font-size-12 font-weg-400 mb-05">{offer.NAME}</p>
                                            {offer.AVAILABLE!='' &&  offer.AVAILABLE>'0' && <p className="font-size-12 font-weg-400 mb-05">Available: {offer.AVAILABLE}</p>}
                                        </div>
                                    </div>
                                );
                            })
                        }
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default SpecialOffers;


// WEBPACK FOOTER //
// ./src/components/SpecialOffers.js